import Vue from 'vue'
import moment from 'moment'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PENarrativesCardActions = {
  initPeNarrativesCard: ({ commit }, index) => {
    commit('setPeNarrativesCardLock', { index, lock: true })
    commit('fixPeNarrativesCard', { index })
  },
  peNarrativesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        narratives: {
          party_id: party.id,
          entry_date: section.entry_date,
          taken_by_id: section.taken_by_id,
          text: section.text,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeNarrativesCardLock', { index, lock: true })
        commit('pePatchParty', {
          narratives: updatedParty.narratives || [],
        })
      }).
      catch(handleError)
  },
  peNarrativesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/narratives/${section.id}`).
      then(({ data }) => {
        commit('setPeNarrativesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'narratives',
          value: data,
        })
      }).
      catch(handleError)
  },
  peNarrativesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        narratives: {
          party_id: party.id,
          entry_date: section.entry_date,
          taken_by_id: section.taken_by_id,
          text: section.text,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeNarrativesCardLock', { index, lock: true })
        commit('pePatchParty', {
          narratives: updatedParty.narratives || [],
        })
      }).
      catch(handleError)
  },
  peNarrativesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          narratives: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeNarrativesCardLock', { index, lock: true })
        commit('pePatchParty', {
          narratives: updatedParty.narratives || [],
        })
      }).
      catch(handleError)
  },
  peNarrativesCardAddSection: ({ commit, rootState }) => {
    const currentUser = rootState.currentUser

    commit('setPeNarrativesCardLock', { index: 'new', lock: false })
    commit('addPeNarrativesCardSection', {
      id: null,
      entry_date: moment().format('YYYY-MM-DD'),
      taken_by_id: currentUser.id,
      text: '',
    })
  },
}

export const PENarrativesCardMutations = {
  setPeNarrativesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.NarrativesCard) Vue.set(state.partyEdit.partySections, 'NarrativesCard', {})
    Vue.set(state.partyEdit.partySections.NarrativesCard, index, lock)
  },
  addPeNarrativesCardSection: (state, section) => {
    state.partyEdit.party.narratives.push(section)
  },
  peNarrativesCardCreateUndo: state => state.partyEdit.party.narratives.pop(),
  fixPeNarrativesCard: (state, { index }) => {
    const narrative = state.partyEdit.party.narratives.find(narrative => narrative.id === index)
    if (!narrative) return
    narrative.entry_date = narrative.entry_date || moment(narrative.created_at, 'YYYY-MM-DD').format('YYYY-MM-DD')
  },
}

export const PENarrativesCardGetters = {
  peNarrativesCardLock: state => index => state.partyEdit.partySections.NarrativesCard[index],
  peNarrativesCardHasNewSection: (_, getters) => !!getters.peParty.narratives?.find(narrative => narrative.id === null),
}
